export default [
  {
    path: '',
    name: 'sale list',
    component: () => import('@/views/app/sale/list/page-list.vue'),
    meta: { title: 'Riwayat Penjualan' },
  },
  {
    path: ':id',
    name: 'sale detail',
    component: () => import('@/views/app/sale/show/page-show.vue'),
    meta: { title: 'Detail Penjualan' },
  },
]
